export default class KeyPopup {
    static createPopup() {
        return `
    <div class="header-container">
        <h2>Accreditations</h2>
        <button class="close-btn" title="Close">
			<i class="fas fa-times" aria-hidden="true"></i>
        </button>
    </div>

	<div class="key-content">
		<a href="https://britishparking.co.uk/Safer-Parking-Scheme-/-Park-Mark" title="Park Mark" target="_blank">
			<i id="pm-icon"></i>
		</a>
        <div class="key-text">
            <h3>Park Mark</h3>
            <p>A rigorous assessment by specially trained police assessors to ensure the safety of people and vehicles through measures to deter criminal activity and anti-social behaviour</p>
        </div>
    </div>

    <div class="key-content">
		<a href="https://britishparking.co.uk/Park-Mark-Plus" title="Park Mark Plus" target="_blank">
			<i id="pmp-icon"></i>
		</a>
        <div class="key-text">
            <h3>Park Mark Plus</h3>
            <p>An elite award, achievable by the highest quality car parks which hold the Park Mark Award and in addition offer exemplary customer experience, environmental credentials, meet the Park Access criteria for disabled parking bays</p>
        </div>
    </div>

	<div class="key-content">
		<a href="https://britishparking.co.uk/park-access" title="Park Access" target="_blank">
			<i id="pa-icon"></i>
		</a>
		<div class="key-text">
			<h3>Park Access</h3>
			<p>A new accreditation quickly becoming the UK's industry standard for accessible and inclusive parking and electric vehicle charging facilities. Developed by merging and enhancing the Disabled Parking Accreditation and People's Parking</p>
		</div>
	</div>

	<div class="key-content">
		<a href="https://britishparking.co.uk/park-mark-freight" title="Park Mark Freight" target="_blank">
			<i id="pmf-icon"></i>
		</a>
		<div class="key-text">
			<h3>Park Mark Freight</h3>
			<p>A new and comprehensive assessment specifically for lorry parks and truck stops, developed in response to the rise in cargo theft in recent years and the Department for Transport's policies for improving roadside facilities for drivers</p>
		</div>
	</div>

    <div class="key-content">
		<a href="https://britishparking.co.uk/AM-GO" title="AM-GO" target="_blank">
			<i id="am-go-icon"></i>
		</a>
		<div class="key-text">
			<h3>AM-GO</h3>
			<p>A new scheme which will become the recognised and trusted standard for airports and off-airport Meet and Greet parking operators. The BPA Approved Meet and Greet Parking Operator Scheme is aimed at reducing crime and the fear of crime in car parks</p>
		</div>
	</div>

    <div class="bpa-logo">
		<p>The BPA is a not-for-profit membership association representing the UK's parking and mobility sector, our vision is for a diverse and inclusive membership community that supports a parking and travel experience that exceeds expectations</p>
		<a id="bpa-logo" href="https://britishparking.co.uk/" title="British Parking Association" target="_blank"></a>
	</div>
    `;
    }
}
